import { render, staticRenderFns } from "./LandParcelHistory.vue?vue&type=template&id=3cc41217&scoped=true&"
import script from "./LandParcelHistory.vue?vue&type=script&lang=js&"
export * from "./LandParcelHistory.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelHistory.vue?vue&type=style&index=0&id=3cc41217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc41217",
  null
  
)

export default component.exports